@if (activateLink()) {
  <button type='button' class="link-primary border-0 bg-transparent"
          (click)="onSmartLinkClick()">{{ textValue() }}
  </button>
} @else {
  {{ textValue() }}
}

